module.exports = __webpack_public_path__ + "static/media/shortinglistdown-white.d8c50fa5.svg";